import React from "react";

const Dashboard = React.lazy(() => import("views/dashboard/dashboard").then(m => ({ default: m.Dashboard })));
const Help = React.lazy(() => import("views/dashboard/help").then(m => ({ default: m.Help })));
const OnboardingView = React.lazy(() => import("views/onboarding/onboarding").then(m => ({ default: m.OnboardingView })));
const Notifications = React.lazy(() => import("views/notifications/notifications").then(m => ({ default: m.Notifications })));
const NotificationHistory = React.lazy(() => import("views/notifications/history").then(m => ({ default: m.NotificationHistory })));
const Drivers = React.lazy(() => import("views/drivers/drivers").then(m => ({ default: m.Drivers })));
const Vehicles = React.lazy(() => import("views/vehicles/vehicles").then(m => ({ default: m.Vehicles })));
const Periods = React.lazy(() => import("views/periods/periods").then(m => ({ default: m.Periods })));
const Clients = React.lazy(() => import("views/clients/clients").then(m => ({ default: m.Clients })));
const Courses = React.lazy(() => import("views/courses/courses").then(m => ({ default: m.Courses })));
const Schools = React.lazy(() => import("views/schools/schools").then(m => ({ default: m.Schools })));
const RouteDesigner = React.lazy(() => import("views/routes/routeDesigner").then(m => ({ default: m.RouteDesigner })));
const RouteEditor = React.lazy(() => import("views/routes/routeEditor").then(m => ({ default: m.RouteEditor })));
const RoutesView = React.lazy(() => import("views/routes/routes").then(m => ({ default: m.Routes })));
const Attendance = React.lazy(() => import("views/attendance/attendance").then(m => ({ default: m.Attendance })));
const LiveRoutes = React.lazy(() => import("views/tracking/liveRoutes").then(m => ({ default: m.LiveRoutes })));
const LiveRouteMap = React.lazy(() => import("views/tracking/liveRouteMap").then(m => ({ default: m.LiveRouteMap })));

const Routes = [
  {
    path: "/live-routes/:id",
    view: LiveRouteMap,
    layout: "app",
    permission: "operations",
    title: "Mapa en Vivo",
  },
  {
    path: "/live-routes",
    view: LiveRoutes,
    layout: "app",
    permission: "operations",
    title: "Monitoreo de Rutas",
  },
  {
    path: "/attendance",
    view: Attendance,
    layout: "app",
    permission: "operations",
    title: "Reportes de Asistencia",
  },
  {
    path: "/routes",
    view: RoutesView,
    layout: "app",
    permission: "operations",
    title: "Gestión de Rutas",
  },
  {
    path: "/route-designer",
    view: RouteDesigner,
    layout: "app",
    permission: "operations",
    title: "Diseñador de Rutas",
  },
  {
    path: "/route-editor",
    view: RouteEditor,
    layout: "app",
    permission: "operations",
    title: "Editar Ruta",
  },
  {
    path: "/dashboard",
    view: Dashboard,
    layout: "app",
    permission: "operations",
    title: "Tablero",
  },
  {
    path: "/welcome",
    view: OnboardingView,
    layout: "onboarding",
    permission: "user",
    title: "Bienvenido",
  },
  {
    path: "/help",
    view: Help,
    layout: "app",
    permission: "user",
    title: "Obtener ayuda",
  },
  {
    path: "/drivers",
    view: Drivers,
    layout: "app",
    permission: "operations",
    title: "Conductores",
  },
  {
    path: "/vehicles",
    view: Vehicles,
    layout: "app",
    permission: "operations",
    title: "Vehículos",
  },
  {
    path: "/periods",
    view: Periods,
    layout: "app",
    permission: "operations",
    title: "Periodos",
  },
  {
    path: "/clients",
    view: Clients,
    layout: "app",
    permission: "operations",
    title: "Clientes",
  },
  /* {
    path: "/school_periods",
    view: SchoolPeriods,
    layout: "app",
    permission: "operations",
    title: "Periodos Lectivos",
  }, */
  {
    path: "/courses",
    view: Courses,
    layout: "app",
    permission: "operations",
    title: "Cursos",
  },
  {
    // Una sola pantalla de notificaciones: el historial.
    path: "/notifications",
    view: NotificationHistory,
    layout: "app",
    permission: "user",
    title: "Notificaciones",
  },
  {
    // Gestión de dispositivos y envíos, enlazada desde el historial.
    path: "/notifications/devices",
    view: Notifications,
    layout: "app",
    permission: "operations",
    title: "Dispositivos y envíos",
  },
  {
    path: "/schools",
    view: Schools,
    layout: "app",
    permission: "operations",
    title: "Colegios",
  },
];

export default Routes;

